var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TileData px-3 pb-4 pt-0",class:{open: _vm.open}},[_c('div',{staticClass:"TileData__Collapse",on:{"click":_vm.toggle}},[_c('div',{staticClass:"TileData__Collapse__Icon",class:{ rotated: _vm.open }},[_c('SvgIcon',{attrs:{"icon":"chevron-left-solid"}})],1)]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }